import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { generateConfig } from "../../utils/api";
import { handleApiError } from "../../utils/apiErrorHandler";

// Fetch all active payroll cohorts
export const fetchPayrollCohorts = createAsyncThunk(
  "payrollCohorts/fetchAll",
  async (_, { rejectWithValue, getState }) => {
    try {
      const state = getState();
      const token = state.auth.token;
      const { baseURL, config } = generateConfig({ token });

      const response = await axios.get(`${baseURL}/api/payroll-cohorts`, config);
      return response.data;
    } catch (error) {
      return handleApiError(error, rejectWithValue);
    }
  }
);

// Fetch a single payroll cohort by ID
export const fetchPayrollCohortById = createAsyncThunk(
  "payrollCohorts/fetchById",
  async (cohortId, { rejectWithValue, getState, dispatch }) => {
    try {
      const state = getState();
      const token = state.auth.token;
      const { baseURL, config } = generateConfig({ token });

      const response = await axios.get(
        `${baseURL}/api/payroll-cohorts/${cohortId}`,
        config
      );
      return response.data;
    } catch (error) {
      return handleApiError(error, rejectWithValue, dispatch);
    }
  }
);

// Create a new payroll cohort
export const createPayrollCohort = createAsyncThunk(
  "payrollCohorts/create",
  async (cohortData, { rejectWithValue, getState, dispatch }) => {
    try {
      const state = getState();
      const token = state.auth.token;
      const { baseURL, config } = generateConfig({ token });

      const response = await axios.post(
        `${baseURL}/api/payroll-cohorts`,
        cohortData,
        config
      );
      return response.data;
    } catch (error) {
      return handleApiError(error, rejectWithValue, dispatch);
    }
  }
);

// Update a payroll cohort
export const updatePayrollCohort = createAsyncThunk(
  "payrollCohorts/update",
  async ({ id, cohortData }, { rejectWithValue, getState, dispatch }) => {
    try {
      const state = getState();
      const token = state.auth.token;
      const { baseURL, config } = generateConfig({ token });

      const response = await axios.patch(
        `${baseURL}/api/payroll-cohorts/${id}`,
        cohortData,
        config
      );
      return response.data;
    } catch (error) {
      return handleApiError(error, rejectWithValue, dispatch);
    }
  }
);

// Delete/deactivate a payroll cohort
export const deletePayrollCohort = createAsyncThunk(
  "payrollCohorts/delete",
  async (cohortId, { rejectWithValue, getState, dispatch }) => {
    try {
      const state = getState();
      const token = state.auth.token;
      const { baseURL, config } = generateConfig({ token });

      await axios.delete(`${baseURL}/api/payroll-cohorts/${cohortId}`, config);
      return cohortId;
    } catch (error) {
      return handleApiError(error, rejectWithValue, dispatch);
    }
  }
);